// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dr-3";
export var flatBottomCorners = "_dr-5";
export var productImage = "_dr-0";
export var quantityContainer = "_dr-2";
export var quantityHeader = "_dr-6";
export var tooltip = "_dr-1";
export var wrapAndEllipsesOverflow = "_dr-4";